import { z } from 'zod';
import { dimensionSlugs } from '@features/reports';
import { TOP_BOTTOM_NAMES } from '@features/lci-report';

const dimensionSlugEnum = z.enum([...dimensionSlugs, ...TOP_BOTTOM_NAMES]);

const dimensionSchema = z.object({
  tableHeader: z.string(),
  checkbox: z.boolean(),
});

const customDimensionFieldsSchema = z.record(
  dimensionSlugEnum,
  dimensionSchema
);

export const formSchemaV2 = z.object({
  campaignName: z.string(),
  summary: z.string(),
  includedSlides: z.object({
    overall: z.object({
      overview: z.boolean(),
      executiveSummary: z.boolean(),
    }),
    salesAttribution: z.object({
      titleSlide: z.boolean(),
      summary: z.boolean(),
      dimensions: z.boolean(),
      newBuyerVsExistingBuyer: z.boolean(),
    }),
    performanceByRetailer: z.object({
      titleSlide: z.boolean(),
      retailerSummary: z.boolean(),
      performanceByTopTwenty: z.boolean(),
    }),
    appendix: z.boolean(),
  }),
  dimensions: customDimensionFieldsSchema,
});

export type FormSchemaV2 = z.infer<typeof formSchemaV2>;

export const defaultValuesV2: FormSchemaV2 = {
  campaignName: '',
  summary: '',
  includedSlides: {
    overall: {
      overview: true,
      executiveSummary: true,
    },
    salesAttribution: {
      titleSlide: true,
      summary: true,
      dimensions: true,
      newBuyerVsExistingBuyer: true,
    },
    performanceByRetailer: {
      titleSlide: true,
      retailerSummary: true,
      performanceByTopTwenty: true,
    },
    appendix: true,
  },
  dimensions: {
    ad_frequency: { tableHeader: '', checkbox: true },
    agency: { tableHeader: '', checkbox: true },
    brand: { tableHeader: '', checkbox: true },
    ad: { tableHeader: '', checkbox: true },
    aud: { tableHeader: '', checkbox: true },
    creative: { tableHeader: '', checkbox: true },
    channel: { tableHeader: '', checkbox: true },
    publisher: { tableHeader: '', checkbox: true },
    site: { tableHeader: '', checkbox: true },
    inv_type: { tableHeader: '', checkbox: true },
    plcmnt: { tableHeader: '', checkbox: true },
    typ: { tableHeader: '', checkbox: true },
    ds: { tableHeader: '', checkbox: true },
    iol: { tableHeader: '', checkbox: true },
    visit_frequency: { tableHeader: '', checkbox: true },
    Top: { tableHeader: '', checkbox: true },
    Bottom: { tableHeader: '', checkbox: true },
  },
};
